module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av574-8729c2b3a76e49288678e1de0dd432a1.jpg";